import type { CSSProperties } from 'react'

/** Shared overflow guard for flex/grid children showing CMS copy */
export const cmsTextBoxBase: CSSProperties = {
  minWidth: 0,
  maxWidth: '100%',
}

/** Flowing CMS body copy — full text, wraps at word boundaries only */
export function cmsParagraph(extra?: CSSProperties): CSSProperties {
  return {
    ...cmsTextBoxBase,
    overflowWrap: 'break-word',
    wordBreak: 'normal',
    whiteSpace: 'pre-line',
    ...extra,
  }
}

/** Single-line CMS text — ellipsis when wider than container */
export function cmsEllipsis(extra?: CSSProperties): CSSProperties {
  return {
    ...cmsTextBoxBase,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    ...extra,
  }
}

/** Multi-line CMS text in fixed boxes — line-clamp; ellipsis only at line ends */
export function cmsClamp(lines: number, extra?: CSSProperties): CSSProperties {
  return {
    ...cmsTextBoxBase,
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: lines,
    WebkitBoxOrient: 'vertical' as const,
    lineClamp: lines,
    textOverflow: 'ellipsis',
    overflowWrap: 'break-word',
    wordBreak: 'normal',
    ...extra,
  }
}

/** Use as native `title` so full CMS string is available on hover */
export function cmsTextTitle(value?: string | null): string | undefined {
  const t = value?.trim()
  return t || undefined
}
